import axios, { CancelTokenSource } from 'axios';
import { useContext, useRef } from 'react';
import useSWR from 'swr';
import {
  AXIOS_CANCEL_MSG,
  Page,
} from '../api/models';
import { ConfiguratorContext } from '../context';
import {TruckReportDto} from "../pages/reports/truckReport";
import {ListTruckRequest} from "../api";
import {display} from "html2canvas/dist/types/css/property-descriptors/display";


type TruckListProps = ListTruckRequest & {
  disabled?: boolean;
}

export const useTruckReport = (props: TruckListProps) => {

  const cancelTokenSourceRef = useRef<CancelTokenSource>();
  const configurator = useContext(ConfiguratorContext);

  const fetcher = async ( props:TruckListProps  ) : Promise<Page<TruckReportDto> | undefined> => {
    if ( props.disabled ) return;

    if ( props.page === -1 ) return;

    if ( cancelTokenSourceRef.current ) {
      cancelTokenSourceRef.current.cancel( AXIOS_CANCEL_MSG );
    }
    const cancelSource = axios.CancelToken.source();
    cancelTokenSourceRef.current = cancelSource;

    try {
      const resp = await configurator.api.fetchTruckReport(props, cancelSource.token )
      cancelTokenSourceRef.current = undefined;

      return resp.data;
    }
    catch(e: any) {
      const id = e.response?.data?.message || e.message ;
      if ( id === AXIOS_CANCEL_MSG ) return;
      throw e;
    }
  }

  // Use SWR for data fetching
  return useSWR([
    'fetchTruckReport',
    props
  ],
    ([_k, p]) => fetcher(p),
    {
      //maybe unnecessary
      shouldRetryOnError: false,
      revalidateOnFocus: false,
      /*
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateOnMount: false,
       */
      //maybe unnecessary
      dedupingInterval:1 
    }
  );
};


export default useTruckReport;

